import { css, html, LitElement } from 'lit';
import { customElement } from 'lit/decorators.js';

interface SocketData {
  name?: string;
  side?: 'input' | 'output';
  value?: unknown;
}

@customElement('white-socket')
export class WhiteSocketElement extends LitElement {
  static get properties() {
    return {
      data: { type: Object },
    };
  }

  declare data: SocketData;

  static styles = css`
    :host {
      --socket-size: 20px;
      display: inline-block;
      position: relative;
      width: var(--socket-size);
      height: var(--socket-size);
    }

    .circle {
      cursor: pointer;
      width: var(--socket-size);
      height: var(--socket-size);
      border-radius: 50%;
      border: 2px solid var(--color-sidebar-surface, var(--color-socket-border));
      background: var(--spectrum-gray-600, var(--color-socket-bg));
      box-sizing: border-box;
      box-shadow: 0 0 0 1px var(--color-app-border, rgba(15, 23, 42, 0.14));
      transition:
        background 0.14s ease,
        box-shadow 0.14s ease;
    }

    .circle:hover {
      background: var(--color-sidebar-selected-border, var(--color-socket-hover-bg));
      box-shadow: 0 0 0 3px rgba(63, 99, 243, 0.14);
    }
  `;

  render() {
    return html` <div class="circle" title="${this.data?.name || ''}"></div> `;
  }
}
